const USER_ROLE =
    Object.freeze(
        {
            SEEKING_SERVICES: 1,
            OFFERING_SERVICES: 2,
            SUPER_ADMIN: 3,
            ADMIN: 4,
            SUPPORT: 5,
            MANAGER: 6,
            VENUE: 7,
            CORE_ADMIN: 8,
            GOD_ADMIN: 9,
            SUPER_GOD_ADMIN: 10,
        }
    );

export default USER_ROLE;
